import { all } from "redux-saga/effects";

import analytics from "./analytics";
import auth from "./auth";
import fetch from "./fetch";
import notification from "./notification";
import redirection from "./redirection";
import refresh from "./refresh";

export default (dataProvider, authProvider, analyticsProvider, config) =>
  function* admin() {
    yield all([
      fetch(dataProvider, authProvider)(),
      auth(authProvider, dataProvider, config)(),
      refresh(),
      notification(),
      redirection(),
      analytics(analyticsProvider, authProvider)(),
    ]);
  };
